import React, { useReducer, useEffect, useContext } from "react";
import { API, graphqlOperation, Auth } from "aws-amplify";
import { listTaxDocuments } from "../graphql/queries";
import {
  onCreateTaxDocument,
  onDeleteTaxDocument,
} from "../graphql/subscriptions";
import { UserContext } from "../App";

const initialState = { attachments: [] };

function reducer(state, action) {
  switch (action.type) {
    case "set":
      console.log("Attachments List:", action.payload);
      return { attachments: action.payload };
    case "add":
      console.log("Inside add", action.payload);
      return { attachments: [...state.attachments, action.payload] };
    case "delete":
      console.log("Inside delete", action.payload);
      return {
        attachments: state.attachments.filter(
          (item) => item.id !== action.payload.id
        ),
      };
    default:
      return;
  }
}

export function useSubscription() {
  const {
    user,
    setUser,
    signOutState,
    setSignOutState,
    taxReturn,
    setTaxReturn,
  } = useContext(UserContext);

  const [state, dispatch] = useReducer(reducer, initialState);

  useEffect(async () => {
    const attachmentData = await API.graphql(
      graphqlOperation(listTaxDocuments)
    );
    dispatch({
      type: "set",
      payload: attachmentData.data.listTaxDocuments.items,
    });
  }, []);

  useEffect(() => {
    console.log("Owner in TaxDocumentsSub", user.username);
    const subscriber = API.graphql({
      query: onCreateTaxDocument,
      variables: {
        owner: user.username,
      },
    }).subscribe({
      next: (data) => {
        const {
          value: {
            data: { onCreateTaxDocument },
          },
        } = data;
        dispatch({ type: "add", payload: onCreateTaxDocument });
      },
    });
    return () => subscriber.unsubscribe();
  }, []);

  useEffect(() => {
    const subscriber = API.graphql({
      query: onDeleteTaxDocument,
      variables: {
        owner: user.username,
      },
    }).subscribe({
      next: (data) => {
        const {
          value: {
            data: { onDeleteTaxDocument },
          },
        } = data;
        dispatch({ type: "delete", payload: onDeleteTaxDocument });
      },
    });
    return () => subscriber.unsubscribe();
  }, []);

  return state.attachments;
}
